// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Countdown_countdown__jUgpa","countdown__item":"Countdown_countdown__item__I0p_c"};